import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

interface Service {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  type: 'discovery' | 'uxui' | 'apps';
}

@Component({
    selector: 'app-services',
    imports: [
        CommonModule,
        TranslateModule,
        AnimateOnScrollDirective
    ],
    templateUrl: './services.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./services.component.scss']
})
export class ServicesComponent {
  
  services: Service[] = [
    {
      title: 'services.discovery.TITLE',
      subtitle: 'services.discovery.SUBTITLE',
      description: 'services.discovery.DESCRIPTION',
      image: 'assets/images/astronauta.png',
      type: 'discovery'
    },
    {
      title: 'services.uxui.TITLE',
      subtitle: 'services.uxui.SUBTITLE', 
      description: 'services.uxui.DESCRIPTION',
      image: 'assets/images/uxui.svg',
      type: 'uxui'
    },
    {
      title: 'services.apps.TITLE',
      subtitle: 'services.apps.SUBTITLE',
      description: 'services.apps.DESCRIPTION',
      image: 'assets/images/app.png',
      type: 'apps'
    }
  ];

} 